import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dymaczew/Documents/_code/mcm/edge-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Do you want to learn more about IBM Edge Application Manager? This is the right place. In the following sections, you will have hands-on experience with IBM Edge Application Manager. To complete the labs, you will use your IBM Edge Application Manager Trial.`}</p>
    <p>{`By now, there are three hands-on labs: Agent Installation, Edge Service Management and Model Management.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "900px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.19444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAC40lEQVQ4y2NgAALzb6cEjdZPsbbaMdfB7csZIZCY7KPVDP+P/GdABv87PzMQBYrP7rBLWzVnbeKG+Usyr+4yAokt2jKHBUQfzV1lf75sc+PW5DnSIP6p3LWMppZ2+A08vnOv09n9h+be3nPI41TdCm4kKcb7DQd2/N/15f+ppJW5YFdu/M9kXzMRLOl69gsQY3H1gYMHTdfv3hE8b/t203u31khe2cspeH6Po3hLn6LIusx5Thfad5Y3+ZdpIOtJTVjEMKvmKfP02luMIoo8DOZWTowmFraYhv//YaV4aKv36oObHabcPq3vhiyX2b4SHAyz/v/H7V1Ta3stEO3bUGFmUZKpt2r2EpmVK1fP2rRla8a6njUKa4MmGq+MnuryP2iLrOWUteGWE1ZusNty2TubgYGpOfdITE3mRm0pNWEhcytHbaALmRjMHF1MZRgYBP23L6y1WzO1vDuj2OTgoUM79h85lHdgykb7HaWL520vX7LqSvPOFr70PF6Twk4ThsUMrOVxmwO3Tfn/f2bdnT0MHAyyNnYeJmaWDoxgV5romfGZubobqdvYGFaW1+kePLjdb9uGSbKT58xR2rxz65Kd+3dvWb5pTQmyzyIDG3Umld9Y0110KhXVy6bWMEPZbY1s2YQkRNlhcksWLZLZs2tP/bGjx6PWTJygqj9/v47ntivtXhNXWKIHnZKmKoOMpggwUXt6MRip6CFJhXI2VBqqT+lUMZHXLuWdMLGNDybjuftOd8bL//+dt12bDYqW+qLDRr3Fl2U+LoJE0pKG30CXWUESaUS4LcT/zOyil4+FXX54OeV/Z4M6WPLIzdWsIDpgyR5Dnx03ZhruvGw0L+SQRHb0guXliZvq/t/4zwySn1v9AeGuxHh4GmI5f9B72a3TAZc7G/RUwQau0mCc9PE/3syR6bMCU7CnQQRuKBCDc8z//2Jw+agr3xiT//9nsn7yn3GSSAJQ7j8YxzhNZYC5EAA4ECi0BdrEEQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "labs overview",
        "title": "labs overview",
        "src": "/edge-demohub/static/c384a839e60f1dc6b1c17e732a297c1e/929af/labs-overview.png",
        "srcSet": ["/edge-demohub/static/c384a839e60f1dc6b1c17e732a297c1e/7fc1e/labs-overview.png 288w", "/edge-demohub/static/c384a839e60f1dc6b1c17e732a297c1e/a5df1/labs-overview.png 576w", "/edge-demohub/static/c384a839e60f1dc6b1c17e732a297c1e/929af/labs-overview.png 900w"],
        "sizes": "(max-width: 900px) 100vw, 900px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`We recommend to follow the sequence above, however if you want to explore one specific lab, you can do it, just check the lab prerequisites section before start.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      